import { render } from "./Informations.vue?vue&type=template&id=d161917a&scoped=true"
import script from "./Informations.vue?vue&type=script&lang=js"
export * from "./Informations.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d161917a"

export default script